export default {
	ANSWER: 'answer',
}
